import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { isAPIError } from '@/store/utils/index';
import type { LoginDTO, LoginRequest, LoginResult, LoginReturn } from '@/types/dtos.types';

const mapCredentialVerificationResult = (result: LoginResult): LoginReturn => ({
  twoFactorToken: result.twoFactorToken,
  maskedEmail: result.maskedEmail,
  maskedPhone: result.maskedPhone,
});

export const loginThunk = createAdminAsyncThunk<LoginResult, LoginDTO>(
  'auth/login',
  async (credentials, { extra: { authService }, rejectWithValue }) => {
    try {
      const request: LoginRequest = {
        username: credentials.username,
        password: credentials.password,
      };
      const result = await authService.login(request);
      const mappedResult = mapCredentialVerificationResult(result);
      return mappedResult;
    } catch (error) {
      if (isAPIError(error)) {
        return rejectWithValue({ fieldErrors: error.message });
      }
      throw error;
    }
  }
);
